module.exports = __webpack_public_path__ + "static/iceDragon-0b7770163f8ebdf0f2425cfce8e7bc5a.jpg";